




























import Vue from "vue";
import axios, { AxiosPromise } from "axios";
import { ApplicationActions } from "../store";
import { Dispatcher, Committer } from "vuex-type-helper";
import { EventBus } from "../lib/EventBus";
import { Autorisatie } from "../Autorisatie";

export default Vue.extend({
  data() {
    return {
      attempt: 0,
      username: "",
      password: "",
      isVerifying: false
    };
  },
  mounted() {
    if (!!this.jwt) this.onJWTChanged();
    document.addEventListener("keydown", this.onKeydown);
  },
  beforeDestroy: function() {
    document.removeEventListener("keydown", this.onKeydown);
  },
  watch: {
    jwt: function(newValue) {
      if (!!newValue) this.onJWTChanged();
    }
  },
  computed: {
    emailState(): null | boolean {
      if (this.attempt > 0) {
        return !!this.username ? null : false;
      }
      return null;
    },
    passwordState(): null | boolean {
      if (this.attempt > 0) {
        return !!this.password ? null : false;
      }
      return null;
    },
    jwt(): string | null {
      return this.$store.getters.jwt;
    },
    importeur(): string | null {
      return this.$store.getters.importeurNaam;
    },
    hasImporteur(): boolean {
      return !!this.importeur;
    },
    iconPath(): string {
      return this.hasImporteur
        ? "/images/logo" + this.importeur + ".png"
        : "/images/icon.png";
    },
    iconLangPath(): string {
      const langicon = this.$i18n.locale === "nl" ? "en_GB" : "nl_NL";
      return "/images/" + langicon + ".png";
    }
  },
  methods: {
    onJWTChanged() {
      let routerName = this.$store.getters.defaultPage();

      if (routerName === "logout") {
        EventBus.$emit("add-toastr", {
          text: `${this.$i18n.t("noauthorizations")}`,
          type: "error"
        });
      }

      this.$router.push({ name: routerName });
    },
    onKeydown(e: any) {
      const escape = 27;
      const enter = 13;
      const arrowUp = 38;
      const arrowDown = 40;

      switch (e.keyCode) {
        case enter:
          this.doLogin();
          break;
      }
    },
    doLogin() {
      this.attempt++;
      if (!this.isVerifying && !!this.username && !!this.password) {
        this.isVerifying = true;

        const settings = {
          UserName: this.username,
          Password: this.password
        };
        axios
          .post("/api/backend/v1/identity/login", settings, {
            timeout: 24 * 60 * 60 * 1000, // 1 dag
            headers: { "Content-Type": "application/json" }
          })
          .then(response => {
            setTimeout(() => {
              this.isVerifying = false;
            }, 500);

            if (
              !!response &&
              !!response.data &&
              !!response.data.Result &&
              !!response.data.JWT &&
              !!response.data.JWT.Token
            ) {
              this.$store.dispatch<Dispatcher<ApplicationActions>>({
                type: "setJWT",
                jwt: response.data.JWT.Token
              });
            } else {
              EventBus.$emit("add-toastr", {
                text: `${this.$i18n.t("logininvalid")}`,
                type: "error"
              });
            }
          })
          .catch(error => {
            this.isVerifying = false;
          });
      }
    },
    switchLang() {
      const newLocale = this.$i18n.locale === "nl" ? "en" : "nl";
      this.$store.dispatch<Dispatcher<ApplicationActions>>({
        type: "setLocale",
        locale: newLocale
      });
    }
  }
});
